import * as React from "react";
import { observer } from "mobx-react-lite";
import { Route, Routes } from "react-router-dom";
import { OrgList } from "./OrgList";
import { OrgDetail } from "./OrgDetail";
import { Helmet } from "react-helmet";
import { IS_TEST_ENVIRONMENT } from "../../envVariables";

const OrgIndexRaw: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>{IS_TEST_ENVIRONMENT ? `TEST | ` : ""}Org - Admin Panel</title>
      </Helmet>
      <Routes>
        <Route path={`:org/*`} element={<OrgDetail />} />
        <Route index element={<OrgList />} />
      </Routes>
    </>
  );
};

export const OrgIndex = observer(OrgIndexRaw);
